import { loggerNamespace } from '../lib/Logger'
import { authService } from './AuthService'

class FileService {
  private logger = loggerNamespace('FileService')

  public uploadTempFile = async (file: File): Promise<{ fileToken?: string, error?: string }> => {
    const formData = new FormData()
    formData.append('filename', file)
    try {
      const url = authService.createAuthorizedUrl('/upload_temp_file', {})
      const { token: fileToken } = await (await fetch(url, {
        method: 'POST',
        body: formData
      })).json()
      return { fileToken }

    } catch (e: Error | any) {
      this.logger.error(e)
      return { error: e.message ?? e.toString() }
    }
  }

  public removeTempFile = async (fileToken: string): Promise<{ result: boolean, error?: string }> => {
    try {
      const url = authService.createAuthorizedUrl('/remove_temp_file', {})
      const { result } = await (await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: fileToken }),
      })).json()
      return { result }

    } catch (e: Error | any) {
      this.logger.error(e)
      return { result: false, error: e.message ?? e.toString() }
    }
  }
}

const fileService = new FileService()
export { fileService }
